export enum IntermediaryRefer {
  // lowercase to match the URL param value sent by JobTread integration
  JobTread = 'jobtread',
}
